module.exports = __webpack_public_path__ + "img/9788932910376.21a4a12b.jpg";